import Navbar from "./Mainsite/Navbar";
import Main from "./Mainsite/Main";
import moment from "moment";
import { Box, Typography, useTheme } from "@mui/material";
import auth from "../Services/loginService";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { useIdleTimer } from "react-idle-timer/legacy";

import { connect } from "react-redux";
function TemplateSite(props) {
  const disconnect = async () => {
    await auth.logout();
    props.logout(undefined);
  };
  const onIdle = () => {
    disconnect();
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: 20 * 60 * 1000,
    throttle: 500,
  });
  const pat = props.selectedPatient;
  const upSite = pat && props.patients?.length > 1 && (
    <Box
      className="detailsTop"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start", // דוחף את השם לימין ואת היציאה לשמאל
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "#f0f0f0" : "background.paper",
        color: "text.primary",
        p: "10px 40px",
        margin: 0,
        gap: 2,
        maxWidth: "100vw",
        overflow: "hidden",
        borderBottom: `1px solid ${(theme) => theme.palette.divider}`,
        transition: "all 0.3s ease",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 700 }}>
          {pat.firstname + " " + pat.lastname}
        </Typography>

        {/* כאן אפשר להוסיף את ה-ID או פרטים נוספים אם תחליט להחזיר את ה-false ל-true */}
        {false && (
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            , ת"ז: {pat.custid}, {pat.sex === 1 ? "בן " : "בת "}
            {pat.birthdate && moment().diff(pat.birthdate, "years")}
          </Typography>
        )}
      </Box>

      <Link
        className="printerHide"
        to={`../patients`}
        onClick={() => pat && props.updateSelectedPatient(undefined)}
        style={{
          textDecoration: "none",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "error.main", // צבע אדום של MUI
            fontWeight: 600,
            borderBottom: "1px solid",
            borderColor: "error.main",
            cursor: "pointer",
            "&:hover": {
              color: "error.dark",
              borderColor: "error.dark",
            },
          }}
        >
          [יציאה]
        </Typography>
      </Link>
    </Box>
  );
  return (
    <div className="webTemplate">
      <Navbar />
      <div
        style={{
          flexGrow: 5,
        }}
      >
        {upSite}
        
        <Main />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedPatient: state.selectedPatient,
    patients: state.patients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSelectedPatient: (pat) => {
      dispatch({
        type: "UPDATE_SELECTED_PATIENT",
        payload: pat,
      });
    },
    logout: (newDetails) => {
      dispatch({
        type: "LOGOUT",
        payload: newDetails,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateSite);
